module.exports = __webpack_public_path__ + "static/media/promo-5.055c1c5c.png";